const learn: Record<string, string | number | null> = {
    'legacy-learn-app-url': (process.env.LEGACY_LEARN_APP_URL as string) || null
}

export const getLearnConfig = () => ({ ...learn })
